import React from 'react';
import EnvironmentBadge from '../../components/environment-badge/environment-badge';

function NotFound() {
  return (
    <div className="bg-white font-sans min-h-screen flex flex-col">
      {/* Outside the layout, so it has no header to carry the testing badge. */}
      <EnvironmentBadge floating />
      <div className="flex-grow flex items-center justify-center p-4">
        <div className="max-w-lg w-full text-center">
          {/* Logo */}
          <div className="mb-8">
            <div className="text-4xl font-bold text-blue-600">OrderGate</div>
          </div>

          {/* Error code */}
          <div className="text-9xl font-extrabold text-blue-500 mb-6">404</div>

          {/* Error message */}
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Payment Page Not Found</h1>
          <p className="text-xl text-gray-600 mb-10">We couldn&#39;t find the payment page you were looking for.</p>

          {/* Action buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-6 mb-10">
            <a
              href="/app"
              className="px-8 py-4 bg-blue-600 text-white text-xl font-semibold rounded-lg shadow-lg hover:bg-blue-700 transition duration-150"
            >
              Back to Application
            </a>
            <a
              href="/support"
              className="px-8 py-4 bg-white text-blue-600 text-xl font-semibold rounded-lg border-2 border-blue-600 hover:bg-blue-50 transition duration-150"
            >
              Contact Support
            </a>
          </div>

          {/* Security notice */}
          <div className="flex items-center justify-center text-lg text-gray-600">
            <svg
              className="w-6 h-6 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
            Secure payment processing
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-6 text-center text-base text-gray-500 border-t border-gray-200">
        <p>&copy; 2025 OrderGate. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default NotFound;
